export class InputValidation {

  static readonly MIN_LENGTH: number = 1;
  static readonly MAX_LENGTH: number = 255;
  static readonly STRING_LENGTH_ERROR_MSG: string = 'COMMON.VALIDATION_MESSAGES.INPUT_VALIDATION_ERROR.LENGTH_VALIDATION';

  static hexColorValidation(color: string): boolean {
    //^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
    ///#[0-9a-f]{6}|#[0-9a-f]{3}/gi
    //^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$
    // /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i


    // /^(#)?([0-9a-fA-F]{3})([0-9a-fA-F]{3})?$/
    let regColorcode = /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i;
    let isValid = regColorcode.test(color);
    return isValid;
  };

  static rgbColorValidation(color: string): boolean {
    //^(rgb)?\(?([01]?\d\d?|2[0-4]\d|25[0-5])(\W+)([01]?\d\d?|2[0-4]\d|25[0-5])\W+(([01]?\d\d?|2[0-4]\d|25[0-5])\)?)$
    let regColorcode = /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
    return regColorcode.test(color);
  };

  static validateStringLength(value: string): boolean {
    let strText: string = value.trim();
    if (strText.length < InputValidation.MIN_LENGTH || strText.length > InputValidation.MAX_LENGTH) {
      return false;
    } else {
      return true;
    }
  }

  static onlyNumberValidation(numberString: string) {
    let regNumber = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/g;
    return regNumber.test(numberString);
  }
}

